import React from 'react';

import type { Row } from 'react-table';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import { Tooltip } from '@bringg/react-components';

import type { RoutesPlannerTranslations } from '../../../../routes-planner/translations';
import type { RoutesPlannerTask } from '../../../../../types';
import { isTaskAssigned } from '../../../../routes-planner/utils';

interface Props {
	row: Row<RoutesPlannerTask>;
	translations: RoutesPlannerTranslations;
	value: string;
}

const PriorityColumn = ({ row, value, translations }: Props) => {
	const renderInfoCircle = () => {
		const unassignedTaskReason =
			row.original.reason || translations.routesTableTranslations.headers.unassignedDefaultReason;

		return (
			<Tooltip title={unassignedTaskReason} data-test-id="unassigned-reason" placement="topRight">
				<span>
					<BringgIcon iconName={BringgFontIcons.Unassigned} className="unassigned-icon" />
				</span>
			</Tooltip>
		);
	};

	return (
		<div data-test-id="priority-cell" className="priority-cell">
			{isTaskAssigned(row.values.run_id) ? value : renderInfoCircle()}
		</div>
	);
};

export default PriorityColumn;
